import { useMutation, useQueryClient } from '@tanstack/react-query';
import { ENDPOINT } from '@constants/endpoint';
import { transformApiErrors } from '@services/Api.serviceTS';
import BasketService from '@services/Basket.service';
import axios from '@utils/axiosInstance';
import getBasketDebounceHandler from '@utils/getBasketDebounceHandler';
import showToast from '@utils/showToast';

const createBasketDish = async ({
  data: dish,
  resolve,
  reject,
  clearStaleRejects,
}) => {
  clearStaleRejects();

  try {
    const response = await axios.post(ENDPOINT.BASKET_ADD_DISH, dish, {
      errorHandle: false,
    });
    const data = response?.data ?? {};
    const uiRows = BasketService.transformResponseBasketUI(data);

    resolve({ ...data, uiRows });
  } catch (error) {
    reject(error);
  }
};

const useCreateBasketDish = ({ basketKey, options = {} } = {}) => {
  const queryClient = useQueryClient();

  const mutationKey = `${basketKey}AddDish`;

  return useMutation({
    mutationFn: ({ shouldDebounce, ...data }) =>
      getBasketDebounceHandler({
        shouldDebounce,
        mutationKey,
        mutationFn: createBasketDish,
        data,
      }),
    mutationKey: [mutationKey],
    onSuccess: response => {
      queryClient.setQueryData([basketKey], response);
    },
    onError: err => {
      const error = err?.response?.data;
      const apiFieldErrors = transformApiErrors(error);

      showToast(apiFieldErrors?.day, { type: 'warning' });
    },
    ...options,
  });
};

export default useCreateBasketDish;
